import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT_CREATE_DB_API = process.env.REACT_APP_CREATE_DB;

export const createNewDb = createAsyncThunk(
  "auth/user-db/new-db",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(
        END_POINT_CREATE_DB_API,
        "POST",
        patchData
      );
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createNewDb_Slice = createSlice({
  name: "createNewDb",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_Create_New_Db: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNewDb.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewDb.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(createNewDb.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Create_New_Db } = createNewDb_Slice.actions;
export default createNewDb_Slice.reducer;
